import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import Actions from '../../../../../../../../../store/actions';
import { PrimaryDark, white } from '../../../../../../../../../styling/theme';
import breakpointsMinWidth from '../../../../../../../../../styling/breakpointsMinWidth';

const Wrapper = styled.span`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 8px;
`;
const Smart = styled.div`
  padding: 2px 4px;
  font-family: Roboto;
  font-style: normal;
  font-size: 12px;
  display: flex;
  align-items: center;

  color: #000000;
  cursor: pointer;
  background-color: #e4effd;
  border-radius: 4px;

  &:hover {
    background: ${PrimaryDark};
    color: ${white};
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

const Manual = styled.div`
  padding: 2px 4px;
  font-family: Roboto;
  font-style: normal;
  font-size: 12px;
  display: flex;
  align-items: center;

  color: #000000;
  cursor: pointer;
  background-color: #e5e5e5;
  border-radius: 4px;
  &:hover {
    background: ${PrimaryDark};
    color: ${white};
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;
class Buttons extends Component {
  state = {};

  handleClick = (e, clb) => {
    e.preventDefault();
    const { editor, node } = this.props;

    const {
      value: {
        focusBlock,
        selection: {
          isFocused,
          isExpanded,
          isCollapsed,
          isForward,
          isBackward,
        },
      },
      moveToEndOfNode,
    } = editor;
    if (focusBlock !== node) {
      moveToEndOfNode(node).focus();
    } else if (
      isFocused &&
      isCollapsed &&
      !isExpanded &&
      !isForward &&
      !isBackward
    ) {
      moveToEndOfNode(node).focus();
    }

    setTimeout(() => clb(), 0);
  };

  render() {
    const { showManualReferenceModal, showReferenceModal } = this.props;
    return (
      <Wrapper>
        <Manual
          onClick={(e) => {
            this.handleClick(e, showManualReferenceModal);
          }}
        >
          <span>Manual</span>
        </Manual>
        <Smart
          onClick={(e) => {
            this.handleClick(e, showReferenceModal);
          }}
        >
          <span>Smart</span>
        </Smart>
      </Wrapper>
    );
  }
}

Buttons.propTypes = {
  node: PropTypes.objectOf(PropTypes.object).isRequired,
  editor: PropTypes.shape({
    resolveController: PropTypes.func,
  }).isRequired,
  showReferenceModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  formatType: state.editResumeFormReducer.formatType,
});

const mapDispatchToProps = (dispatch) => ({
  showReferenceModal: () =>
    dispatch(Actions.referenceModalActions.toggleReferenceModal()),
  showManualReferenceModal: () =>
    dispatch(Actions.referenceModalActions.toggleManualReferenceModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Buttons);
